import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import DownloadCard from "../../components/DownloadCard/DownloadCard";
import "./DownloadPage.scss";

function DownloadPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sessionId = location.state?.sessionId || null;
  const videoFileName = location.state?.videoFileName || "AV_Sync_Output";
  const jobId = sessionId?.jobId || null;

  // If no sessionId/jobId, redirect back to sync
  useEffect(() => {
    if (auth.isAuthenticated && (!sessionId || !jobId)) {
      navigate("/sync", { replace: true });
    }
  }, [auth.isAuthenticated, sessionId, jobId, navigate]);

  const _email = auth.user?.profile?.email || auth.user?.profile?.sub || "User";

  return (
    <div className="dp-page">
      <main className="tab-panel">
        <DownloadCard
          videoFileName={videoFileName}
          jobId={jobId}
          onBack={() => navigate("/sync", { state: { sessionId, videoFileName } })}
        />
      </main>
    </div>
  );
}

export default DownloadPage;
